








































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Setting as mainTerms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { EditAd as feedbackTerms } from '@/const/terms/feedback/ad';
import { EditAdFolder as feedbackOfAdFolder } from '@/const/terms/feedback/adFolder';

import { ID_TYPE } from '@/const/types';
import { AdFolderType } from '@/pages/campaign/adset/ad/editingTypes';

import { ElTable } from 'element-ui/types/table';
import { AxiosError, AxiosResponse } from 'axios';
import { AdFolderLoadFilters } from '@/pages/campaign/adset/ad/editingTypes';
import { IAdFolderData, AdFolderResponse } from '@/pages/adFolder/types';
import { ELTABLE_FORMAT } from '@/utils/elTable_formatter';

@Component<AdFolderSelectDialog>({
    name: 'AdFolderSelectDialog',
})
export default class AdFolderSelectDialog extends Vue {
    @Prop({type: Array, required: true}) private value!: AdFolderType[];
    @Prop({type: Function, required: true}) private getUsableCreativeHandler!: (arr: ID_TYPE[]) => Promise<any>;
    @Prop({type: Number, required: true}) private subLoading!: number;
    @Prop({type: Boolean, required: true}) private adFolderDialogVisible!: boolean;

    get appliedAdFolders() { return this.value }
    set appliedAdFolders(v: AdFolderType[]) { this.$emit('input', v) }

    get adFolderDialogVisibleSync() { return this.adFolderDialogVisible }
    set adFolderDialogVisibleSync(v: boolean) { this.$emit('update:adFolderDialogVisible', v) }

    get subLoadingSync() { return this.subLoading }
    set subLoadingSync(v: number) { this.$emit('update:subLoading', v)}

    private terms = mainTerms;
    private compTerms = compTerms;
    
    private DateFormat = ELTABLE_FORMAT.DateFormat;

    private blockSelection: boolean = false;
    private maxSelect: number = 15;
    private adFolderList: AdFolderType[] = [];
    
    private isAdFolderLoading: boolean = false;
    
    private adFolderLoadFilterForm: AdFolderLoadFilters = {
        name: '',
        page: 1,
        totalPages: 0,
    }
    private keepSelectedAdFolders: AdFolderType[] = [];
    private selectedAdFolders: AdFolderType[] = [];

    private loadAdFolderHandler() {
        this.appliedAdFolders = [
            ...this.selectedAdFolders,
            ...this.keepSelectedAdFolders,
        ]
        this.$nextTick(() => {
            const idList = this.appliedAdFolders.map((item: AdFolderType)=> item.id);        
            this.$emit('submit', idList);
        })
    }
    private adFolderSelectHandler(val: AdFolderType[], row: AdFolderType) {
        if (this.selectedAdFolders.length + this.keepSelectedAdFolders.length > this.maxSelect) {
            const table = this.$refs.adFolderTable as ElTable;
            this.blockSelection = true;
            if (row) {
                table.toggleRowSelection(row);
            } else {
                table.clearSelection();
            }
        } else {
            this.blockSelection = false;
        }
    }
    private adFolderSelectChangedHandler(val: AdFolderType[]) {
        this.selectedAdFolders = val;
    }
    
    private makeAdFolderHandler() {
        const routerData = this.$router.resolve({name: 'adFolderNew'});
        const child = window.open(routerData.href, '_blank') as Window;
        if (child.postMessage) {
            let message = 'adFolderNewRequest';
            let callCnt = 10;
            let msgHandler = setInterval(()=>{
                if (callCnt <= 0) {
                    clearInterval(msgHandler);
                    return;
                }
                child.postMessage(message, child.origin);
                callCnt--;
            }, 500);

            window.addEventListener('message', (e) => {
                if (e.origin === window.origin) {
                    if (e.data === message + 'true') {
                        if (msgHandler) clearInterval(msgHandler);
                        this.$notify.success(feedbackOfAdFolder.new.success);
                        this.getAdFolderListHandler();
                        return;
                    }
                    if (e.data === message + 'false') {
                        if (msgHandler) clearInterval(msgHandler);
                        // statement
                        return;
                    }
                    if (e.data === message + 'ready') {
                        callCnt = 10;
                        msgHandler = setInterval(()=>{
                            if (callCnt <= 0) {
                                clearInterval(msgHandler);
                                return;
                            }
                            child.postMessage(message, child.origin);
                            callCnt--;
                        }, 500);
                        return;
                    }
                    if (e.data === message + 'connected') {
                        if (msgHandler)
                            clearInterval(msgHandler);
                        return;
                    }
                }
            })
        } else {
            child.onclose = () => {
                this.getAdFolderListHandler();
            }
        }
    }
    
    private getAdFolderListHandler() {
        const keepedID = this.keepSelectedAdFolders.map((v: IAdFolderData) => v.id);
        this.keepSelectedAdFolders = this.keepSelectedAdFolders.concat(
            ...this.selectedAdFolders.filter((v: IAdFolderData) => !keepedID.includes(v.id))
        );
        this.isAdFolderLoading = true;

        const table = this.$refs.adFolderTable as ElTable;

        return this.getAdFolderList().then((res: any) => res.data)
            .then((data: AdFolderResponse) => {
                this.adFolderList = data.folders;
                this.adFolderLoadFilterForm.totalPages = data.pages;
                return data;
            })
            .then((data: AdFolderResponse) => {
                if (this.keepSelectedAdFolders.length) {
                    data.folders.forEach((row: IAdFolderData) => {
                        const keeped = this.keepSelectedAdFolders.find((v)=>v.id === row.id);
                        if (keeped) {
                            table.toggleRowSelection(row);
                            this.keepSelectedAdFolders.splice(this.keepSelectedAdFolders.indexOf(keeped), 1);
                        }
                    })
                }  
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.editing.error.getResponse);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.isAdFolderLoading = false;
            })
    }
    
    private getAdFolderList(): Promise<any> {
        return this.$http.adserverAPI.post('GetCreativeFolderSummary', {
            query: this.adFolderLoadFilterForm.name,
            page_no: this.adFolderLoadFilterForm.page,
        });
    }
    
    private created() {
        this.getAdFolderListHandler();
    }
}
